{
    "services-money-transfers": {
        "meta": {
            "title": "Money Transfers - MAJORITY",
            "description": "Save on sending money internationally! Send no-fee money transfers abroad at competitive exchange rates with quick and secure delivery."
        },
        "hero": {
            "title": "International money transfers",
            "body": "Send money abroad fee-free.",
            "cta": "I send money to",
            "features": "Competitive exchange rates\nGenerous transfer limits"
        },
        "send_save_more_content_box": {
            "tagline": "Money transfer",
            "title": "Send more and save more",
            "body": "You can send international money transfers without hidden fees. That means you spend less to send more money to your family back home. Plus, your transfers are quick, easy, and secure.",
            "canvas": "Amazing rates"
        },
        "exchange_rates_content_box": {
            "tagline": "Money transfer",
            "title": "Money transfers with amazing exchange rates",
            "body": "We help you save on sending money abroad by offering competitive exchange rates to all destinations."
        }
    }
}